import React from 'react';

import { Avatar, Box, Button, Typography, useTheme } from '@mui/material';
import RoleTag from 'app/shared/components/loanApplication/RoleTag';
import { ROLE_TYPES } from 'app/shared/components/loanApplication/RoleTag/RoleTag.constants';
import PropTypes from 'prop-types';

import { getPersonInitials } from 'utils/loanApplication';

import { userPropTypes } from './UserCard.constants';
import {
  buttonStyles,
  descriptionStyles,
  getStyles,
  headStyles,
  headTextContent,
  titleStyles,
  wrapperStyles,
} from './UserCard.styles';
import { UserCardTestIds } from './UserCard.testIds';

const UserCard = ({ userData }) => {
  const theme = useTheme();
  const classes = getStyles(theme);

  const { firstName, lastName, roleName } = userData;

  const isName = !!(firstName && lastName);

  return (
    <Box sx={wrapperStyles}>
      <Box sx={headStyles}>
        <Avatar sx={classes.avatar}>{getPersonInitials({ firstName, lastName })}</Avatar>

        <Box sx={headTextContent}>
          <Typography sx={titleStyles} variant="regular14">
            {isName ? `${firstName} ${lastName}` : 'Unnamed'}
          </Typography>
          <RoleTag roleType={ROLE_TYPES.INTERNAL}>{roleName ?? 'Unknown'}</RoleTag>
        </Box>
      </Box>

      <Typography sx={descriptionStyles} variant="regular14">
        Assigned to loan.
      </Typography>

      <Button
        disabled
        data-testid={UserCardTestIds.VIEW_LOAN_EDITS_BUTTON}
        sx={buttonStyles}
        variant="contained"
      >
        View loan edits
      </Button>
    </Box>
  );
};

UserCard.propTypes = {
  userData: PropTypes.shape(userPropTypes).isRequired,
};

export default UserCard;
